class FirehawkCRMStockFilters {
    container = null;
    filtersContainer = null;
    filters = [];
    filterValues = {};

    hasFilters = () => {
        return this.filters && this.filters.length > 0
    }

    filterValueChanged = (fitler, value) => {};

    constructor(container, options) {
        this.container = container;

        if (options.filtersContainer) {
            this.filtersContainer = options.filtersContainer;
        } else {
            this.filtersContainer = jQuery(this.container).find(".fcrm-filters-container");
        }

        this.addListeners()
    }

    buildFilters(params) {
        if (!this.filtersContainer) return;
        this.fetchFiltersData(params, (filters) => {
            if (!filters) {
                this.clearFiltersView();
                return;
            }

            this.clearFiltersView();
            this.builderFiltersView();
        })
    }

    fetchFiltersData(params, callback) {
        params.size = 1000;

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_stock_filters',
				params: params
			}
		}).done((response) => {
            let filters = response && response.filters || []
            this.filters = filters
            if (callback) {
                callback(filters)
            }
		}).fail((error) => {
			console.error(error)
            if (callback) {
                callback([])
            }
		})
    }

    clearFiltersView() {
        if (!this.filtersContainer) return;
        this.filtersContainer.innerHTML = "";
    }

    builderFiltersView() {
        if (!this.filtersContainer) return;
        if (!this.filters) return;

        for (let filter of this.filters) {
            let group = this.buildFilterGroup(filter)
            if (group) {
                this.filtersContainer.append(group)
            }
        }
    }

    buildFilterGroup(filter) {
        let groupDiv = document.createElement('div');
        groupDiv.className = 'filter-group';
       
        if (filter.type == "picker") {
            let groupContent = `
                <div class="title collapse-header">${filter.title}<span class="far fa-angle-right"></span></div>
                <div class="collapse-panel">
                    <div class="options-list checklist-group" data-filter-id="${filter.id}">
            `;
            if (filter.options && filter.options.length) {
                for (let i in filter.options) {
                    let index = +i;
                    let option = filter.options[index];

                    groupContent += `
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="${filter.id}" id="${filter.id}${index}" value="${option.value}">
                        <label class="form-check-label" for="${filter.id}${index}">${option.label}</label>
                    </div>
                    `;
                }
            }

            groupContent += `</div></div>`;
            groupDiv.innerHTML = groupContent;
        } else if (filter.type == "sort") {
            groupDiv.className = "filter-group sort-group";
            let groupContent = `
                <div class="title">${filter.title}</div>
                <select class="form-select" aria-label="Select options to sort products" id="${filter.id}">
            `;
            if (filter.options && filter.options.length) {
                for (let option of filter.options) {
                    groupContent += `<option value="${option.value}">${option.label}</option>;
                    `
                }
            }

            groupContent += `</select>`;
            groupDiv.innerHTML = groupContent;
        }

        return groupDiv
    }

    addListeners() {
        if (!this.filtersContainer) return;
        this.filtersContainer.delegate(".filter-group .collapse-header", "click", (event) => {
            let current = jQuery(event.currentTarget)
            if (current.hasClass("open")) {
                current.removeClass("open")
            } else {
                current.addClass("open")
            }
        })

        this.filtersContainer.delegate(".form-check-input", "change", (event) => {
            let field = jQuery(event.currentTarget)
            let fieldId = field.attr("name");
            let filter = this.filters && this.filters.filter(f => f.id == fieldId)[0];
            let checkedValues = [];

            this.filtersContainer.find(`.checklist-group input[name="${fieldId}"]:checked`).each(function() {
                checkedValues.push(jQuery(this).val());
            });

            console.log("Filter values", fieldId, filter, checkedValues)
            
            this.filterValues[fieldId] = checkedValues;
            
            if (this.filterValueChanged) {
                this.filterValueChanged(filter, checkedValues)
            }
        });
    }
}